<div class="tab_body">
    <fury-list>
        <fury-list-table>
            <div class="table_container">
            <table class="lead_list" [dataSource]="dataSource" mat-table>
                <form [formGroup]="searchForm">
                <!-- actions Column -->
                <ng-container matColumnDef="actions" stickyEnd>
                    <th *matHeaderCellDef class="actions-cell" mat-header-cell>
                        <div>
                            <div class="search" (click)="search()">
                                <mat-icon>search</mat-icon>
                            </div>
                        </div>
                        <h3>
                            Actions
                        </h3>
                    </th>
                    <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                        <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                            (click)="$event.stopPropagation()">
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                            <button mat-menu-item (click)="openDetails(row)">
                                <span>Details</span>
                            </button>
                            <button mat-menu-item (click)="redirectToViewClaim(row)">
                                <span>View Claim</span>
                            </button>
                            <button mat-menu-item (click)="handleClaimNote(row)">
                                <span>Claim Notes</span>
                            </button>
                            <button mat-menu-item *ngIf="row?.isCompanyAssigned" (click)="handleViewAssignedTechnician(row)">
                                <span>View Assigned Technician</span>
                              </button>
                            <button mat-menu-item (click)="handleAssignTechnician(row, 'assignOrEditTechnician')">
                                <span>Assign Technician</span>
                            </button>
                            <button mat-menu-item *ngIf="row?.isTechnicianAssigned" (click)="handleTechnicianSchedule(row, 'addTechnicianSchedule')">
                                <span>Add Technician Schedule</span>
                            </button>
                            <button mat-menu-item  (click)="handleAttachDocument(row)">
                                <span>Attach Documents</span>
                            </button>
                            <button mat-menu-item (click)="handleClaimChangesLog(row)">
                              <span>Claim Changes Log</span>
                            </button>
                            <!-- <button mat-menu-item (click)="handleClaimHistory(row)">
                                <span>Claim Assignment History</span>
                            </button> -->
                            <button mat-menu-item (click)="changeStatus(row)">
                              <span>Change Status</span>
                          </button>
                        </mat-menu>
                    </td>
                </ng-container>

                <ng-container matColumnDef="priority" sticky>
                    <th mat-header-cell *matHeaderCellDef>
                      <div>
                          <input type="text" placeholder="Created At" style="visibility: hidden;"/>
                          <h3>
                            Priority
                          </h3>
                      </div>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div [ngClass]="(element?.priority || '').toLowerCase() ==='emergency'  ? 'emergency' : 'normal'" matTooltip="{{(element?.priority || '').toLowerCase() ==='emergency' ? 'Emergency' : ''}}" matTooltipShowDelay="300">
                    </div>
                </td>
                  </ng-container>
    
                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef>
                    <div>
                        <input type="text" placeholder="Created At" style="visibility: hidden;"/>
                        <h3>
                            Created At
                        </h3>
                    </div>
                </th>
                  <td mat-cell *matCellDef="let element">
                      {{element?.createdAt | date : 'MMM-dd-YYYY h:mm a'}}
                  </td>
                </ng-container>
    
                <ng-container matColumnDef="fileClaimNumber">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Claim Number" formControlName="claimNumber"/>
                            <h3>
                                Claim Number
                            </h3>
                        </div>
                    </th>
                  <td mat-cell *matCellDef="let element">
                      {{element?.fileClaimNumber}}
                  </td>
                </ng-container>
    
                <ng-container matColumnDef="firstName">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="First Name" formControlName="firstName"/>
                            <h3>
                                First Name
                            </h3>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.firstName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Last Name" formControlName="lastName"/>
                            <h3>
                                Last Name
                            </h3>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.lastName}}
                    </td>
                </ng-container>
    
                <ng-container matColumnDef="phoneNumber">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Phone Number" formControlName="phoneNumber" mask="0*"/>
                            <h3>
                                Phone Number
                            </h3>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.phoneNumber | mask : "(000) 000-0000"}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="emailAddress">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Email Address" formControlName="emailAddress"/>
                            <h3>
                                Email Address
                            </h3>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.emailAddress}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="address">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Address" formControlName="address"/>
                            <h3>
                                Address
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.propertyAddress?.address.split(",")[0]}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="city">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="City" formControlName="city"/>
                            <h3>
                                City
                            </h3>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.propertyAddress?.city}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="state">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="State" formControlName="state"/>
                            <h3>
                                State
                            </h3>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.propertyAddress?.state}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="zip">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Zip" formControlName="zip" mask="0*"/>
                            <h3>
                                Zip
                            </h3>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.propertyAddress?.zip}}
                    </td>
                </ng-container>
    
                <ng-container matColumnDef="agreementNumber">
                  <th mat-header-cell *matHeaderCellDef>
                    <div>
                        <input type="text" placeholder="Agreement Number" formControlName="agreementNumber"/>
                        <h3>
                            Agreement Number
                        </h3>
                    </div>                   
                </th>
                  <td mat-cell *matCellDef="let element">
                      {{element?.agreementNumber}}
                  </td>
              </ng-container>
            
                <ng-container matColumnDef="coveredItem">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Cover Item" formControlName="coveredItem"/>
                            <h3>
                                Cover Item
                            </h3>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.coveredItem}}
                    </td>
                </ng-container>
          
                <ng-container matColumnDef="transactionId">
                  <th *matHeaderCellDef mat-header-cell>
                    <div>
                        <input type="text" placeholder="Transaction Id" style="visibility: hidden;"/>
                        <h3>
                            Transaction Id
                        </h3>
                    </div>
                </th>
                  <td mat-cell *matCellDef="let element">
                    {{element?.paymentDetails?.transactionId}}
                </td>
              </ng-container>
              <ng-container matColumnDef="cardType">
                <th *matHeaderCellDef mat-header-cell>
                    <div>
                        <input type="text" placeholder="Card Type" style="visibility: hidden;"/>
                        <h3>
                            Card Type
                        </h3>
                    </div>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{element?.paymentDetails?.cardType}}
              </td>
            </ng-container>
            <ng-container matColumnDef="amount">
                <th *matHeaderCellDef mat-header-cell>
                    <div>
                        <input type="text" placeholder="Amount" style="visibility: hidden;"/>
                        <h3>
                            Amount
                        </h3>
                    </div>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{element?.paymentDetails?.amount | currency}}
              </td>
            </ng-container>
    
            <ng-container matColumnDef="availability">
                <th *matHeaderCellDef mat-header-cell>
                    <div>
                        <input type="text" placeholder="Availability" style="visibility: hidden;"/>
                        <h3>
                            Availability
                        </h3>
                    </div>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{element?.availability}}
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th *matHeaderCellDef mat-header-cell>
                    <div>
                        <select formControlName="status">
                            <option value="">Status</option>
                            <option *ngFor="let item of status" [value]="item?.statusName">{{item?.statusName}}</option>
                        </select>
                        <h3>
                            Status
                        </h3>
                    </div>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{element?.status}}
              </td>
            </ng-container>
    
                <tr *matHeaderRowDef="visibleColumns; sticky: true" mat-header-row></tr>
                <tr *matRowDef="let row; columns: visibleColumns"
                    class="clickable route-animations-elements" mat-row>
                </tr>
            </form>
            </table>
            </div>
            <div *ngIf="dataSource?.length === 0" style="padding: 10px 0; text-align:center;">
                No claims found.
            </div>
        </fury-list-table>
    
    </fury-list>
</div>